import { omitBy } from 'lodash'
import {
  MAX_PRICE_CENTS,
  MAX_PRICE_DOLLARS,
  MAX_SQFT,
  MAX_YEAR_BUILT,
  MIN_BATHROOMS_COUNT,
  MIN_BEDROOMS_COUNT,
  MIN_PRICE_CENTS,
  MIN_PRICE_DOLLARS,
  MIN_SQFT,
  MIN_YEAR_BUILT,
  PROPERTY_TYPES,
  STATUSES,
} from '../../constants/listings'

export const constructFiltersAndOmitEmpty = rawData =>
  omitBy(constructFilters(rawData), value => !value)

export const constructFilters = rawData => {
  const maxPriceCents = parseInt(rawData[MAX_PRICE_CENTS], 10) || null
  const maxPriceDollars = parseInt(rawData[MAX_PRICE_DOLLARS], 10) || null
  const maxSqft = parseInt(rawData[MAX_SQFT], 10) || null
  const maxYearBuilt = rawData[MAX_YEAR_BUILT] || null
  const minBathroomsCount = parseInt(rawData[MIN_BATHROOMS_COUNT], 10) || null
  const minBedroomsCount = parseInt(rawData[MIN_BEDROOMS_COUNT], 10) || null
  const minPriceCents = parseInt(rawData[MIN_PRICE_CENTS], 10) || null
  const minPriceDollars = parseInt(rawData[MIN_PRICE_DOLLARS], 10) || null
  const minSqft = parseInt(rawData[MIN_SQFT], 10) || null
  const minYearBuilt = rawData[MIN_YEAR_BUILT] || null
  const propertyTypes = rawData[PROPERTY_TYPES] || []
  const statuses = rawData[STATUSES] || []

  const filters = {
    [MAX_PRICE_CENTS]:
      maxPriceCents || (maxPriceDollars && maxPriceDollars * 100),
    [MAX_SQFT]: maxSqft,
    [MAX_YEAR_BUILT]: maxYearBuilt,
    [MIN_BATHROOMS_COUNT]: minBathroomsCount,
    [MIN_BEDROOMS_COUNT]: minBedroomsCount,
    [MIN_PRICE_CENTS]:
      minPriceCents || (minPriceDollars && minPriceDollars * 100),
    [MIN_SQFT]: minSqft,
    [MIN_YEAR_BUILT]: minYearBuilt,
    [PROPERTY_TYPES]: propertyTypes,
    [STATUSES]: statuses,
  }

  return filters
}
